const URL_API = "https://api.whizzkenya.com/v1/";


export default URL_API;